
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 512 512"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M450.153 261.601V146.965c0-19.869-16.179-36.024-36.071-36.024h-87.457l-9.873-35.169c-.912-4.09-4.599-7.052-8.783-7.052H160.215c-4.249 0-7.855 2.9-8.784 7.062l-10.424 35.16H54.108v-.001c-19.896 0-36.072 16.158-36.072 36.024v219.149c0 19.868 16.179 36.024 36.072 36.024H306.68a131.918 131.918 0 002.532 18.016H54.108C24.268 420.154 0 395.917 0 366.116V146.965c0-29.801 24.268-54.038 54.108-54.038h73.452l6.43-21.661c2.625-11.853 13.473-20.552 26.234-20.552h147.751c12.4 0 23.374 8.654 26.278 20.66l.172.738 5.861 20.813h73.805c29.839 0 54.107 24.235 54.107 54.038v117.554a131.426 131.426 0 00-18.045-2.916zm-330.509-10.189c0-63.036 51.347-114.308 114.465-114.308 63.101 0 114.44 51.281 114.44 114.308-.002 63.017-51.342 114.298-114.44 114.298-63.117 0-114.465-51.272-114.465-114.298zm210.868-.01c0-53.101-43.252-96.295-96.403-96.295-53.17 0-96.429 43.193-96.429 96.295 0 53.103 43.262 96.285 96.429 96.285 53.161.001 96.403-43.192 96.403-96.285zm55.29-90.413c0-9.169 7.44-16.618 16.639-16.618 9.179 0 16.621 7.448 16.63 16.618 0 9.176-7.441 16.615-16.63 16.615-9.199 0-16.639-7.438-16.639-16.615z"}}),_c('path',{attrs:{"d":"M340.752 380.47c-5.363 0-9.627-4.401-9.627-9.766s4.264-9.627 9.627-9.627h71.041v-71.049c.008-5.364 4.409-9.766 9.773-9.766s9.627 4.401 9.627 9.766v71.049h71.039c5.364 0 9.768 4.263 9.768 9.627s-4.402 9.766-9.768 9.766h-71.039v71.049c0 5.363-4.263 9.767-9.627 9.767s-9.766-4.402-9.766-9.767V380.47h-71.048z"}})])
          )
        }
      }
    